import React from 'react';
import { theme } from '@fiverr-private/theme';
import { SYSTEM_ICON_SIZES } from '../../constants';
import type { SystemIconType } from '../../types';

const ShareIcon = ({ size = 'sm', color = 'currentColor' }: SystemIconType) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={SYSTEM_ICON_SIZES[size]}
    height={SYSTEM_ICON_SIZES[size]}
    fill={theme.colors[color]}
    viewBox="0 0 14 16"
  >
    <path
      fillRule="evenodd"
      d="M10.692 1.827a1.558 1.558 0 1 0 0 3.115 1.558 1.558 0 0 0 0-3.115M8.576 5.592a3.058 3.058 0 1 0-.796-1.271L5.425 5.793a3.058 3.058 0 1 0 0 4.414l2.357 1.472a3.058 3.058 0 1 0 .796-1.271L6.22 8.935a3.06 3.06 0 0 0 0-1.87zM4.624 7.167l.01.016c.147.237.231.517.231.817a1.55 1.55 0 0 1-.242.835A1.557 1.557 0 0 1 1.75 8a1.558 1.558 0 0 1 2.874-.833m4.73 4.65.035-.055a1.558 1.558 0 1 1-.035.056"
      clipRule="evenodd"
    />
  </svg>
);
ShareIcon.id = 'ShareIcon';
ShareIcon.displayName = 'ShareIcon';
export default ShareIcon;
